export const LANGUAGES = {
    ENG: 'en',
    EST: 'et',
    PL: 'pl',
    LAT: 'lv',
    ROM: 'ro',
    DE: 'de',
} as const;
